import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ListItemComponent} from '../list-item/list-item.component';
import {NgClass, NgForOf, NgIf} from '@angular/common';
import {ThemeService} from '../../services/theme-service';
import {ActivatedRoute, Router} from '@angular/router';
import {OrderService} from '../../services/order.service';
import {MenuService} from '../../services/menu.service';
import {ConfigService} from '../../services/config.service';
import {combineLatest, Subscription} from 'rxjs';
import {AppStateService} from '../../services/app-state.service';
import {AppState} from '../../models/AppState';
import {MenuUtils} from '../../utils/Utils';
import {MenuCategory, MenuItem, MenuSection} from '../../models/FSMenu';
import {PrebookMenu} from '../../models/Order';
import {HiresDirective} from '../../directives/hires.directive';
import {OrderPageNavComponent} from '../ui/order-page-nav.component';
import {MenuItemComponent} from '../ui/menu-item.component';
import {PrebookBannerComponent} from '../ui/prebook-banner.component';
import {BottomSheetService} from '../../services/bottom-sheet.service';
import {TranslateService} from '../../services/translate.service';

@Component({
  selector: 'app-menu-page',
  standalone: true,
  imports: [
    ListItemComponent,
    NgForOf,
    NgClass,
    NgIf,
    HiresDirective,
    OrderPageNavComponent,
    MenuItemComponent,
    PrebookBannerComponent
  ],
  templateUrl: './menu-page.component.html',
  styleUrl: './menu-page.component.css'
})
export class MenuPageComponent implements OnInit, OnDestroy, AfterViewInit {
  sections?: MenuSection[];
  sectionsExludingRoot?: MenuSection[];
  visibleRootCategories?: MenuCategory[];
  @ViewChild('pageContentDiv') contentDiv!: ElementRef;
  private isLoading = false;
  pageId: string | null = null;
  private appState: AppState | null = null;
  private sub?: Subscription;
  private sub2?: Subscription;
  title?: string;
  icon?: string;
  topImage?: string;
  // The prebook guest menu this page is, if it is one, and whether the venue shows it compact
  prebookMenu?: PrebookMenu;
  compactMenu = false;
  showWhen = false;
  displayOutine = false;

  constructor(public themeService: ThemeService, private router: Router,
              private orderService: OrderService, private menuService: MenuService,
              private configService: ConfigService, private route: ActivatedRoute,
              private appStateService: AppStateService, private bottomSheetService: BottomSheetService,
              private translate: TranslateService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.beginObserving();
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.sub2?.unsubscribe();
  }

  ngAfterViewInit() {
    const topOffset = this.contentDiv.nativeElement.getBoundingClientRect().top;
    this.contentDiv.nativeElement.style.setProperty('--top-offset', `${topOffset}px`);
  }

  private beginObserving() {
    this.sub = combineLatest([
      this.route.paramMap,
      this.appStateService.observeAppState(),
      this.menuService.observeAddendum(),
      this.translate.getTranslationsReceivedSubject()
    ]).subscribe(([pm, appState, addendum, t]) => { // "addendum" here is necessary for "out of stock" state to be updated
      this.isLoading = false;
      this.pageId = pm.get("page_id");
      this.appState = appState;
      this.title = this.pageId === MenuUtils.MENU_PAGE_FOOD ? "Mat" : "Dryck";
      this.icon = this.pageId === MenuUtils.MENU_PAGE_FOOD ? "fa-utensils" : "fa-glass-water";
      this.showWhen = appState.order?.user_cfg?.when_tag != null;
      this.prebookMenu = MenuUtils.prebookMenus(appState).find(menu => menu.id === this.pageId);
      this.compactMenu = appState.order?.prebook?.template?.menu_layout === 'compact';
      //this.topImage = "https://lh3.googleusercontent.com/QyubIhq0rUOF6qn7-Wz2_PELU2Q9wR1vBJYZzv_0wkgNuQWALFXML3q31TlPO1iJpPDD13_VFgFR2-KbQh5EznD1NSsgUMHqeh4";

      let ss = MenuUtils.getPageSections(this.appState, this.pageId!);
      this.sections = MenuUtils.filterSections(ss) || [];
      this.translate.sections(this.sections);
      this.sectionsExludingRoot = this.sections.filter( s => s.id !== '__root');
      this.topImage = MenuUtils.getPageTopImage(this.appState, this.pageId!);
      const rootSection = this.sections.find( s => s.id === '__root');
      console.log("Root section: ", rootSection);
      this.visibleRootCategories = MenuUtils.filterRootCategories(rootSection);
      this.translate.categories(this.visibleRootCategories);
      if (this.visibleRootCategories) {
        for (const cat of this.visibleRootCategories) {
          this.menuService.buildVisibleItems(cat.items);
          this.translate.items(cat.items);
        }
      }

      const emptyMenu = this.menuService.isMenuEmpty(this.visibleRootCategories, this.sections);
      const nav = this.appStateService.navOnMenuPage(this.pageId!, this.appState, emptyMenu);
      if (nav != null) {
        this.router.navigate(nav);
      }

      this.displayOutine = this.themeService.outlineColor != null;
    });

    // this.sub2 = this.translate.translationsReceivedSubject.subscribe(() => {
    //   console.log("MenuPageComponent translations received");
    //   //Recived translations for sections make sure angular redraws ui
    //   this.cdr.detectChanges();
    // });
  }

  selectSection(id: string) {
    console.log("Navigating to section: " + id);
    this.router.navigate([this.appStateService.venueId, "menu", this.pageId, id]);
  }

  displayItem(item: MenuItem) {
    this.bottomSheetService.displayItem(item);
  }

  getVisibleItems(category: MenuCategory): MenuItem[] | undefined {
    const visibleItems = category.items.filter((item) => !item.mhide && item.class !== 'promo');
    return visibleItems;
  }

  getPrice(item: MenuItem): string {
    return this.orderService.getPriceForItem(item) || item.formatted;
  }

  getString(s: string) {
    return this.translate.getString(s);
  }
}
